import { formatNumber } from '@field-support/shared';

/** Kilometres with one decimal, from metres: `1,234.5`. */
export const km = (meters: number) => formatNumber(kmValue(meters));

/** The same one-decimal kilometres as a number (exports write numbers, not text). */
export const kmValue = (meters: number) => Math.round(meters / 100) / 10;

/** Hours with one decimal, from minutes (shift lengths). */
export const hoursValue = (minutes: number) => Math.round((minutes / 60) * 10) / 10;

/** "92.5%", or "—" when there was no tracking. */
export const percent = (value: number | null) => (value === null ? '—' : `${formatNumber(value)}%`);

/** The business zone: a reporting day runs midnight to midnight here, wherever the viewer is (the backend's APP_TIMEZONE). */
export const APP_TIME_ZONE = 'Africa/Cairo';

const appDay = new Intl.DateTimeFormat('en-GB', { timeZone: APP_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit' });

/** Today as ISO `YYYY-MM-DD` in Cairo (the UTC date is still yesterday just after Cairo midnight). */
export function appToday(now = new Date()): string {
  const parts = Object.fromEntries(appDay.formatToParts(now).map((p) => [p.type, p.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

/** Calendar arithmetic on an ISO `YYYY-MM-DD` day (no zone or clock change involved). */
export function addDays(day: string, days: number): string {
  const date = new Date(`${day}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

/**
 * A name inside a plain-string sentence (a dialog title, a toast), wrapped in Unicode first-strong
 * isolates so an Arabic name in English text, or the reverse, cannot reorder its neighbours (UX audit #16).
 */
export const isolate = (text: string) => `\u2068${text}\u2069`;

/** File sizes as the previous app wrote them (one decimal, MB). */
export const megabytes = (bytes: number) => `${(bytes / (1024 * 1024)).toFixed(1)}\u00A0MB`;
